module.exports = __webpack_public_path__ + "static/media/self-managed_hand-cell-phone.b48baf4d.png";